define(
	'actions/organizer',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes",
	"shared/crm"
	],
	function($,_,Backbone,React,AppDispatcher,Constants, CRM){
		return Backbone.Model.extend({
			init: function(params) {
			},
			addItem: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATED_ORGANIZER,
					data: params
				});
			},
			updatedItem: function(guid, params) {
				AppDispatcher.dispatch({
					actionType: Constants.UPDATED_ORGANIZER,
					guid: guid,
					data: params
				});
			},
			deletedItem: function(guid) {
				AppDispatcher.dispatch({
					actionType: Constants.DELETED_ORGANIZER,
					guid: guid
				});
				AppDispatcher.dispatch({
					actionType: Constants.DELETED_BUNCEE,
					guid: guid
				})
			},
			pull: function(parent, onComplete) {
				var self = this;
				var items = [];
				var guid_folders = [];

				var params = {};
				if (parent) {
					params.parent_guid = parent;
				}
				
				window.api.request("organizer",params).each(function iterator (index, item) {
					items.push({
						guid: item.data.guid,
						title: item.data.title,
						type: item.data.type,
						owner_guid: item.data.owner_guid,
						parent_guid: item.data.parent_guid,
						created_at: item.data.created_at,
						deleted_at: item.data.deleted_at,
						updated_at: item.data.updated_at,
						thumbnail_url: item.data.thumbnail_url,
						links: item.links,
						creation_version: parseInt(item.data.creation_version),
					});
					if(items.length == 50) {
						self.addItem(items);
						items = [];
					}
					if(item.data.type == "folder") {
						guid_folders.push(item.data.guid);
					}
				}, function () {
					self.addItem(items);
					if (typeof onComplete === "function") {
						onComplete();
					}
					
					if(guid_folders.length > 0) {
						for(var p = 0; p < guid_folders.length; p += 30) {
							self.pull(guid_folders.slice(p, p+30));
						}
					} else {
						AppDispatcher.dispatch({
							actionType: Constants.FETCHED_ORGANIZER
						});
					}
				});
			},
			createFolder: function(parent, name) {
				var self = this;
				if(!name) {
					name = "New Folder";
				}
				window.api.request("organizer").create({"type":"folder","name":name,"folder_guid":parent}).done(function(response) {
					console.log("organizer folder created!");
					self.addItem({
						guid: response.data.guid,
						title: response.data.name,
						type: "folder",
						owner_guid: response.data.owner_guid,
						parent_guid: response.data.parent_guid==""?null:response.data.parent_guid,
						created_at: response.data.created_at,
						updated_at: response.data.updated_at,
						links: response.links
					});
					CRM.event("folder:create", response.data);
				});
			},
			duplicate: function(parent, sources, success, failure, successMessage) {
				var self = this;
				var params = parent ? {"folder_guid":parent,"sources":JSON.stringify(sources)} : {"sources":JSON.stringify(sources)};
				window.api.request("organizer/duplicate").create(params).done(function(response) {
					console.log("duplicated!");
					
					self.addItem({
						guid: response.data.guid,
						title: response.data.title,
						type: "buncee",
						owner_guid: response.data.owner_guid,
						parent_guid: response.data.folder_guid == "" ? null : response.data.folder_guid,
						created_at: response.data.created_at,
						updated_at: response.data.updated_at,
						links: response.links,
						thumbnail_url: response.data.thumbnails[0],
						creation_version: response.data.creation_version,
					});
					CRM.event("buncee:duplicate", response.data);
					if(typeof success != "undefined")
						success();
					window.toast(successMessage || "Duplication Success");
				}).fail(function(jqXHR, textStatus, errorThrown) {
					failure();
					if(jqXHR.status == 423) {
						window.showBunceesLimitModal();
					}
					if (jqXHR.status == 403) {
						window.toast('This Buncee is not copyable.');
					}
				});
			},
			delete: function(guid, success, failure) {
				var self = this;
				window.api.request("organizer", guid)
				.delete({})
				.done(function (response) {
					if(typeof success != "undefined"){
						success();
					}
					console.log("organizer folder deleted!");
					self.deletedItem(guid);
					CRM.event("organizer:delete", {guid:guid});
				})
				.fail(function (jqXHR, textStatus, errorThrown) {
					failure();
					console.error(jqXHR);
					alert("Uh-Oh!", jqXHR.responseText || "Your request could not be completed at this time.", {
						message: "Close"
					});
				});
			},
			rename: function(guid, new_name) {
				var self = this;
				window.api.request("organizer", guid).update({"title":new_name}).done(function(response) {
					console.log("organizer folder renamed!");
					self.updatedItem(guid, {"title": new_name});
					CRM.event("organizer:rename", {guid:guid});
				});
			},
			move: function(parent, sources, callback) {
				var params = {
					sources: JSON.stringify(sources),
					destination_guid: parent
				};
				
				if(sources.indexOf(parent) >= 0) {
					toast("You can't move items to the selected folder. Please check the items and try it agian.");
					return;
				}

				var ConnectToStores = require("shared/connect-to-stores");
				var ancestors = _.pluck(ConnectToStores.organizer.getBreadCrumbs(parent), 'guid');
				
				var isChild = _.some(ancestors, function (ancestor) {
					return sources.indexOf(ancestor) >= 0;
				});

				if(isChild) {
					toast("You can't move items to the selected folder. Please check the items and try it agian.");
					return;
				}

				var self = this;
				window.api.request("organizer/move").update(params).done(function (response) {
					console.log("organizer folder moved!");

					_.each(sources, function (guid) {
						self.updatedItem(guid, {"parent_guid": parent});
					});

					if(typeof callback == "function") {
						callback();
					}

					CRM.event("organizer:move");
				});
			}
		});
	}
);
